import { createFileRoute } from "@tanstack/react-router";

import { CaseListPage } from "../../pages/cases/CaseList.page";

export const Route = createFileRoute("/_protected/cases/")({
  component: CaseListPage,
});
